export const moneyRegTransfer = /^[1-9]\d*(\.\d{1,2})?$|^0(\.\d{1,2})?$/;//有2位小数点
export const moneyRegDeposit = /^[1-9]\d*(\.\d{1,2})?$|^0(\.\d{1,2})?$/;//有2位小数点
export const moneyReg = /^[1-9]\d*$/;//不能有小数点
export const CCNumberReg = /^[0-9]{16}$/;;
export const CCPINReg = /^[0-9]{10}$/;;
export const OldBankSixNumReg = /^[0-9]{6}$/;;










// https://arcadie.atlassian.net/wiki/spaces/P1M1M2/pages/88375962/Field+check+APP+Mobile+M1
import moment from 'moment'
// 密码正则
export const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\^\#\$\@]{6,14}$/;
//用户名正则
export const nameReg = /^[a-zA-Z0-9]{6,14}$/;
// 手机号正则
export const phoneReg = /^(1[3-9])\d{9}$/;
// 真实姓名正则
export const nameTest = /^[\u4e00-\u9fa5\u0E00-\u0E7F]{2,20}$/;
//虚拟币钱包名称
export const cryptoWalletName = /^[a-zA-Z0-9\u4e00-\u9fa5\u0E00-\u0E7F]{1,20}$/;
//城市，省份
export const cityReg = /^[a-zA-Z0-9\s\/\#\:\?\,\.\&\(\)\!\-\？\！\，\。\：\（\）\u4e00-\u9fa5\u0E00-\u0E7F]{1,20}$/;
// 微信
export const weChatReg = /^[a-zA-Z0-9\-\_]{4,20}$/;
//安全问题答案
export const questionReg = /^[a-zA-Z0-9\s\/\#\:\?\,\.\&\(\)\!\-\？\！\，\。\：\（\）\u4e00-\u9fa5\u0E00-\u0E7F]{1,500}$/;
//备注
export const remarkReg = /[^a-zA-Z0-9\s\/\#\:\?\,\.\&\(\)\!\-\？\！\，\。\：\（\）\u4e00-\u9fa5\u0E00-\u0E7F]/;
//银行卡号码
export const bankNumReg = /^[0-9]{8,20}$/;
//邮编
export const zipCodeReg = /^[0-9]{4,20}$/;
//身份证
export const documentIdReg = /[0-9]{17}[0-9xX]$/i;
//LB存款旧账号
export const oldBankReg = /^[0-9]{6}$/;
//金额正则

// 邮箱正则
export const emailReg = /^[A-Za-z0-9_\.]+(?:\.[a-zA-Z0-9_\.\-]){0,}@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;



export const bonusCodeReg = /^[a-zA-Z0-9]{6,14}$/;
export const addressReg =  /^[a-zA-Z0-9\s\/\#\:\?\,\.\&\(\)\!\-\？\！\，\。\：\（\）\u4e00-\u9fa5\u0E00-\u0E7F]{2,500}$/;



//小于大于18岁
export const Age18 = (froms) => {
	
	const YMD = moment(froms).format('YYYY-MM-DD').split('-')
	const year = YMD[0]
	const month = YMD[1]
	const date = YMD[2]
	let day = new Date(),
		yearNow = day.getFullYear(),
		monthNow = day.getMonth() + 1,
		dateNow = day.getDate();

	if (yearNow - year > 18 || (yearNow - year == 18 && monthNow > month) ||
		(yearNow - year == 18 && monthNow == month && dateNow >= date)) {
		return true;
	} else {
		return false;
	}
}

// 代理码正则
export const affReg = /^[a-zA-Z0-9]{4,20}$/;

// 邮箱遮挡
export function maskEmail(email = 'xx@xx.com') {
	let result = '';
	const emailPrefix = email.split("@")[0];
	const emailSuffix = email.split("@")[1];
	result = emailPrefix.slice(0,4) + '******' + '@' + emailSuffix

	return result;
}

// 手机遮挡
export function maskPhone(phone = 'xxxxxxxxxx') {
	// const result = phone.substring(0, 3) + "*******" + phone.substring(10, 14);
	const result = phone.slice(0, 3) + "****" + phone.slice(-4);
	return result
}

// 手机遮挡只显示后4位数
export function maskPhone4(phone = 'xxxxxxxxxx') {
	if (!phone) { return '' }
	const result = "*******" + phone.slice(-4);
	return result
}
